import React from 'react';
import { motion } from 'framer-motion';

/**
 * Page header component
 * Contains website title and language options
 */
const Header = () => {
  return (
    <motion.header 
      className="py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="flex items-center">
        <motion.div
          whileHover={{ rotate: 10, scale: 1.1 }}
          className="text-3xl mr-2"
          aria-hidden="true"
        >
          🐾
        </motion.div>
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
          <span className="text-primary">Random Animal</span> Generator
        </h1>
      </div>
      
      {/* Navigation links */}
      <div className="hidden sm:flex items-center space-x-4">
        <a href="/" className="px-3 py-2 text-sm rounded-md hover:bg-background-dark transition-colors">
          Home
        </a>
        <a href="/articles" className="px-3 py-2 text-sm rounded-md hover:bg-background-dark transition-colors">
          Articles
        </a>
        <button className="px-2 py-1 text-sm rounded-md hover:bg-background-dark transition-colors">
          English
        </button>
      </div>
    </motion.header>
  );
};

export default Header; 